const $ = (typeof jQuery == 'undefined') ? require('jquery') : jQuery;

const imkt = window.imkt || (window.imkt = {});
imkt.ui = imkt.ui || {};
imkt.utils = imkt.utils || {};

class VideoEmbedInline {
  constructor(domRoot, params) {
    this.domRoot = $(domRoot);
    this.link = $('.play-trigger', this.domRoot);
    this.params = $.extend({}, {}, params);
    this.videoId = this.params.videoId;
    this.uniqueId = this.params.uniqueId;
    this.source = this.params.source ? this.params.source : 'youtube';
    this.behavior = this.params.behavior;
    this.userLeftPage = false;
    this.playerOrigin = '*';
    this.player;
    this.imWidth;
    this.vidWidth;
    this.vidHeight;
    this.init();
  }

  init() {
    if (this.source === 'youtube') {
      const tag = document.createElement('script');
      tag.id = 'youtube-api';
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];

      if (!document.getElementById('youtube-api')) {
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
    }
    if (!imkt.core.is.mobile()) {
      this.link.on("click", $.proxy(this.onclick, this));
    }
  }

  getVidPlayer() {
    let self = this;
    if (this.source === 'youtube') {
      return '<div id="player-' + self.videoId + '-' + self.uniqueId + '"><img alt="video thumbnail" width="100%" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAABFJREFUKBVjYBgFoyFAhRAAAAJJAAFEkgypAAAAAElFTkSuQmCC"></div>';
    }
    /* else, vimeo */
    if (this.behavior === 'modal' || this.behavior === 'overlaySection') {
      this.modal.$overlay.on("modal.hide", function() {
        self.modal.$modalContent.html('');
      });
    }

    let vimFrame = document.createElement('iframe');
    vimFrame.setAttribute('src', 'https://player.vimeo.com/video/' + self.videoId + '?api=1&amp;autoplay=1&amp;player_id=vimeoplayer-' + self.videoId + '-' + self.uniqueId);
    vimFrame.id = 'vimeoplayer-' + self.videoId + '-' + self.uniqueId;
    vimFrame.width = self.vidWidth;
    vimFrame.height = self.vidHeight;
    this.player = vimFrame;
    return this.player;
  }

  onclick(e) {
    this.imWidth = window.innerWidth - 40;
    if (this.behavior == "replaceImage") {
      this.imWidth = $('img', this.domRoot).width();
    }

    this.vidWidth = window.innerWidth < 1024 || this.behavior === 'replaceImage' ? this.imWidth : 1024;
    this.vidHeight = this.vidWidth * 0.5625;
    e.preventDefault();
    let self = this;
    /* vimeo API requires call before */
    if (this.source === 'vimeo') {
      this.onVimeoIframeAPIReady();
    }

    if (this.behavior === 'none') {
      /* simply link to video */
    } else if (this.behavior === 'replaceImage') {
      /* youtube api takes care of this - only vimeo requires special step */
      console.log(this.domRoot.find('.vid-thumb'))
      this.domRoot.find('.vid-thumb').html(this.getVidPlayer())
    } else {
      // default to modal //

      if (!this.modal) {
        if (this.behavior === 'overlaySection') {
          var nearestContainer = this.domRoot.closest("section, .container-fluid");

          if (nearestContainer.height() < 576) {
            this.vidHeight = nearestContainer.outerHeight();
            this.vidWidth = this.vidHeight * 1.7777;
          }
          this.modal = new imkt.ui.Modal({
            modalType: "video",
            fixed: false,
            centerVertically: false,
            modalContainer: nearestContainer,
            id: this.params.videoId
          });
        } else {
          this.modal = new imkt.ui.Modal({
            modalType: "video"
          });
        }
      }
      this.modal.$modalContent.html(self.getVidPlayer.bind(self));
      if (this.behavior === 'overlaySection') {
        this.modal.$overlay
          .on("modal.show", $.proxy(function(e) {
            this.modal.params.modalContainer.addClass("modal-video");
          }, this))
          .on("modal.hide", $.proxy(function(e) {
            this.modal.params.modalContainer.removeClass("modal-video");
          }, this));
      }
      this.modal.show();
      this.modal.place();
    }

    /* youtube API requires call after */
    if (this.source === 'youtube') {
      this.onYouTubeIframeAPIReady();
    }
  }

  onVimeoIframeAPIReady() {
    if (window.addEventListener) {
      window.addEventListener('message', this.onVimeoMessage.bind(this), false);
    } else {
      window.attachEvent('onmessage', this.onVimeoMessage.bind(this), false);
    }
  }

  onYouTubeIframeAPIReady() {
    let self = this;
    self.player = new YT.Player('player-' + self.videoId + '-' + self.uniqueId, {
      width: self.vidWidth,
      height: self.vidHeight,
      videoId: self.videoId,
      playerVars: {
        autoplay: 1,
        rel: 0,
        origin: window.location.origin,
        widget_referrer: window.location.origin
      },
      events: {
        'onStateChange': self.onYoutubeStateChange.bind(self)
      }
    });

    if (self.behavior === 'modal' || self.behavior === 'overlaySection') {
      self.modal.$overlay.on("modal.hide", function() {
        self.userLeftPage = true;
        if (self.player.pauseVideo) {
          setTimeout(() => self.player.pauseVideo(), 500);
        }
      });
    }

    window.onbeforeunload = function() {
      self.userLeftPage = true;
      if (self.player.pauseVideo) {
        setTimeout(() => self.player.pauseVideo(), 500);
      }
    };
  }

  onYoutubeStateChange(event) {
    let self = this;
    let currentTime = event.target.getCurrentTime();
    let totalTime = event.target.getDuration();
    let percentage = (currentTime / totalTime) * 100;

    let info = {
      event: "Interaction",
      eventComponent: "Video",
      videoTitle: event.target.getVideoData().title,
      videoId: event.target.getVideoData().video_id,
      videoURL: event.target.getVideoUrl(),
      pageURL: window.location.href,
      currentTime: self.secsToTime(currentTime),
      currentPercentage: Math.round(percentage * 10) / 10
    };

    switch (event.data) {
      case YT.PlayerState.PLAYING:
        info.eventType = currentTime < 1 ? 'video_started' : 'video_resumed';
        imkt.utils.tracking.trackEvent('Video-Event', info);
        break;
      case YT.PlayerState.PAUSED:
        info.eventType = self.userLeftPage ? 'video_abandoned' : 'video_paused';
        imkt.utils.tracking.trackEvent('Video-Event', info);
        break;
      case YT.PlayerState.ENDED:
        info.eventType = 'video_completed';
        imkt.utils.tracking.trackEvent('Video-Event', info);
        break;
      default:
        return;
    }
  }

  onVimeoMessage(event) {
    let self = this;
    if (!(/^https?:\/\/player.vimeo.com/).test(event.origin)) {
      return false;
    }

    if (this.playerOrigin === '*') {
      this.playerOrigin = event.origin;
    }

    let data = JSON.parse(event.data);

    let info = {
      event: "Interaction",
      eventComponent: "Video",
      videoId: self.videoId,
      videoURL: 'https://vimeo.com/' + self.videoId,
      pageURL: window.location.href,
      currentTime: self.secsToTime(data.data ? data.data.seconds : 0),
      currentPercentage: data.data ? data.data.percent : 0
    };

    switch (data.event) {
      case 'ready':
        self.onVimeoReady();
        break;
      case 'play':
        info.eventType = info.currentTime === '0s' ? 'video_started' : 'video_resumed';
        imkt.utils.tracking.trackEvent('Video-Event', info);
        break;
      case 'pause':
        info.eventType = self.userLeftPage ? 'video_abandoned' : 'video_paused';
        imkt.utils.tracking.trackEvent('Video-Event', info);
        break;
      case 'finish':
        info.eventType = 'video_completed';
        imkt.utils.tracking.trackEvent('Video-Event', info);
        break;
    }
  }

  vimeoPost(action, value) {
    let vimeoplayer = $('#vimeoplayer-' + this.videoId + '-' + this.uniqueId);
    let data = {
      method: action
    };
    if (value) {
      data.value = value;
    }
    let message = JSON.stringify(data);
    if (vimeoplayer[0]) {
      vimeoplayer[0].contentWindow.postMessage(message, this.playerOrigin);
    }
  }

  onVimeoReady() {
    this.vimeoPost('addEventListener', 'play');
    this.vimeoPost('addEventListener', 'pause');
    this.vimeoPost('addEventListener', 'finish');
  }

  secsToTime(num) {
    let h = num >= 3600 ? Math.floor(num / 3600) + 'h ' : '';
    let m = num >= 60 ? Math.floor(num % 3600 / 60) + 'm ' : '';
    let s = num >= 0 ? Math.floor(num % 3600 % 60) + 's' : '';
    return h + m + s;
  }
}

export default VideoEmbedInline;